module.exports = __webpack_public_path__ + "static/media/image-card-3.b7172b9b.png";